import {ChangeDetectorRef, Component, EventEmitter, forwardRef, OnInit, Output} from "@angular/core";
import {FormBuilder, FormControl} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {PackingUnitService} from "../../services/packing-unit/packing-unit.service";
import {PackingUnit} from "../../../shared/view-model/store-management/packing-unit.type";
import {appInjector} from "../../../index";
import {environment} from "../../../../environments/environment";
import {SessionActions} from "../../../shared/actions";

@Component({
  selector: 'vb-packing-unit-selection',
  templateUrl: './packing-unit-selection.component.html',
  styleUrls: ['./packing-unit-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => PackingUnitSelectionComponent)}]
})
export class PackingUnitSelectionComponent extends AbstractVisbosControl<PackingUnit, FormControl> implements OnInit {

  packingUnitList: PackingUnit[] = [];

  @Output()
  selectedItemChanged: EventEmitter<PackingUnit> = new EventEmitter<PackingUnit>();

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private puService: PackingUnitService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();

    this.puService.getPackingUnitList().subscribe((pus: any) =>{
      this.packingUnitList = pus;
    });

  }

  buildControlContent(): FormControl {
    return PackingUnitSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null,): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  packingUnitSelected(pu: PackingUnit) {
    this.selectedItemChanged.emit(pu);
  }

  public setDefaultValues(item?: PackingUnit): {[controlKey: string]: any} | any {
    return this.setValue(item, 'cuid', environment.selection.packing_unit_id);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/product/packing-unit-selection/packing-unit-selection.component.ts